import { module } from "angular";
import { PageLoadingOverlayComponent } from "./PageLoadingOverlayComponent";

module("mmGui").component("irPageLoadingOverlay", new PageLoadingOverlayComponent());
